(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/react/components/media-queries/mobile.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/react/components/media-queries/mobile.js');

'use strict';

const {
  loginMethods
} = svs.iam_login.constants;
const {
  useAtomValue
} = jotai;
const {
  activeMethodAtom
} = svs.iam_login.atoms;
const {
  BankIdMain
} = svs.iam_login.components.bank_id;
const {
  FrejaMain
} = svs.iam_login.components.freja;
const Mobile = () => {
  const activeMethod = useAtomValue(activeMethodAtom);
  return activeMethod === loginMethods.bankid ? React.createElement(BankIdMain, {
    showQR: false
  }) : React.createElement(FrejaMain, {
    showQR: false
  });
};
svs.iam_login.components.media_queries.Mobile = Mobile;

 })(window);